!function($) {

  // Add custom JavasScript here
  // --------------------------
  // Document ready
  $(function() {
    
    $('.hc-popup-trigger').magnificPopup({
      removalDelay: 500, //delay removal by X to allow out-animation
      callbacks: {
        beforeOpen: function() {
          this.st.mainClass = this.st.el.attr('data-effect');
        }
      },
      closeOnContentClick: false,
      closeOnBgClick: false,
      midClick: true // allow opening popup on middle mouse click. Always set it to true if you don't provide alternative source.
    });

    function isIE() {
      ua = navigator.userAgent;
      var is_ie = ua.indexOf("MSIE ") > -1 || ua.indexOf("Trident/") > -1;

      return is_ie; 
    }
    if (isIE()){
      $('.hc-popup-trigger').trigger('click');
    }
  });

}(jQuery);